import React from 'react';
import PropTypes from 'prop-types';
import RsTableHeaderSortControl from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderSortControl';
import { getAriaSortFromSortList } from '@Pages/RetroSynthesis/components/RsTable/RsTableSortControlUtils';

function ConditionsTableHeader({ sort, onSortChange }) {
  return (
    <tr className="c-els-table__row c-els-table__row--head c-els-table__row--sticky">
      {/* P2-3 — SDD §9.4: dedicated column header for the row-selection checkboxes,
          giving AT users a clear structural relationship between header and cells */}
      <th
        scope="col"
        className="rx-table-row__select c-els-table__cell c-els-table__basic-cell c-els-table__cell--header"
        aria-label="Select">
        <span className="sr-only">Select</span>
      </th>
      <th
        scope="col"
        className="rx-table-row__name c-els-table__cell c-els-table__basic-cell c-els-table__cell--header"
        aria-sort={getAriaSortFromSortList(sort, 'name')}>
        <RsTableHeaderSortControl sortList={sort} sortParam="name" onChange={onSortChange}>
          Project name
        </RsTableHeaderSortControl>
      </th>
      <th
        scope="col"
        className="rx-table-row__date c-els-table__cell c-els-table__basic-cell c-els-table__cell--header"
        aria-sort={getAriaSortFromSortList(sort, 'date')}>
        <RsTableHeaderSortControl sortList={sort} sortParam="date" onChange={onSortChange}>
          Date
        </RsTableHeaderSortControl>
      </th>
      <th scope="col" className="rx-table-row__reference c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
        Source
      </th>
      <th scope="col" className="rx-table-row__reaction c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
        Input reaction
      </th>
      <th scope="col" className="rx-table-row__results c-els-table__cell c-els-table__basic-cell c-els-table__cell--header">
        Results
      </th>
    </tr>
  );
}

ConditionsTableHeader.propTypes = {
  sort: PropTypes.array.isRequired,
  onSortChange: PropTypes.func.isRequired,
};

export default ConditionsTableHeader;
